 export default function parsePythonStyleJson(str) {
  if (typeof str !== 'string') return null;

  try {
    return JSON?.parse(
      str
        ?.replace(/'/g, '"')
        ?.replace(/\bFalse\b/g, 'false')
        ?.replace(/\bTrue\b/g, 'true')
    );
  } catch (e) {
    console.log("Invalid JSON input:", str);
    return null;
  }
}